// extracted by mini-css-extract-plugin
export var explainable = "_ki-a";
export var printerCard = "_ki-1";
export var printerCardConfigured = "_ki-2";
export var printerCardError = "_ki-3";
export var printerCardsContainer = "_ki-0";
export var printerIcon = "_ki-8";
export var printerIconConfigured = "_ki-5";
export var printerIconContainer = "_ki-4";
export var printerIconError = "_ki-6";
export var printerIconUnconfigured = "_ki-7";
export var workstationsTableCard = "_ki-9";